import React from 'react'
import styled from 'styled-components'

import chefImg from '@/assets/images/stickers/chef.gif'
import { GradientTextButton } from '@/components/ui/gradient-text-button'
import { CTA_MAP } from '@/components/common/cta'
import { mobile } from '@/utils/media-query'

const Background = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 434px;
  background: linear-gradient(-135deg, rgb(0, 255, 153) 0%, rgb(153, 51, 255) 100%);
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${mobile.css`
        width: 100%;
        padding: 0 14px;
    box-sizing: border-box;
    `}

  h1 {
    text-align: center;

    ${mobile.css`
            width: 100%;
            margin-bottom: 5px;
            line-height: normal;
        `}
  }

  img {
    width: 120px;
    height: 120px;
    margin-bottom: 20px;

    ${mobile.css`
            width: 100px;
            height: 100px;
            margin-top: -5px;
        `}
  }

  p {
    text-align: center;
    margin-bottom: 37px;
    color: white;
    font-size: 20px;
    line-height: 28px;

    ${mobile.css`
            width: 100%;
            margin-bottom: 25px;
        `}
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  & > :first-child {
    margin-right: 20px;
  }

  ${mobile.css`
        width: 100%;
        flex-direction: column;
        align-items: center;
        height: 96px;
        margin-bottom: 0;

        & > :first-child {
            margin-right: 0;
        }
    `}
`

export const EndBreaker = () => {
  const { PrimaryBodyCTA } = CTA_MAP.default

  return (
    <Background>
      <Container>
        <img alt="" width={120} height={120} src={chefImg} />
        <h1>Ready to get started?</h1>
        <p>Create a GIPHY developer account and start integrating today!</p>
        <Buttons>
          {PrimaryBodyCTA && (
            <PrimaryBodyCTA
              CreateAccountButtonProps={{
                ButtonComponent: GradientTextButton,
                ButtonProps: { text: 'Create Account' },
              }}
              ReadDocsButtonProps={{
                ButtonComponent: GradientTextButton,
                ButtonProps: { text: 'Read the Docs' },
              }}
            />
          )}
        </Buttons>
      </Container>
    </Background>
  )
}
